'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _getUserLogoUrl = require('../../../../utils/getUserLogoUrl');var _getUserLogoUrl2 = _interopRequireDefault(_getUserLogoUrl);
var _PhoneButton = require('../PhoneButton/PhoneButton');var _PhoneButton2 = _interopRequireDefault(_PhoneButton);
var _ContactWrapper = require('../ContactWrapper/ContactWrapper');var _ContactWrapper2 = _interopRequireDefault(_ContactWrapper);
var _RealtorContact = require('./RealtorContact.scss');var _RealtorContact2 = _interopRequireDefault(_RealtorContact);
var _constructLink = require('../../../../helpers/constructLink');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

RealtorContact = function (_Component) {_inherits(RealtorContact, _Component);function RealtorContact() {_classCallCheck(this, RealtorContact);return _possibleConstructorReturn(this, _Component.apply(this, arguments));}RealtorContact.prototype.
  render = function render() {var _props =
    this.props,contact = _props.contact,translate = _props.translate,locale = _props.locale,onRevealPhone = _props.onRevealPhone,className = _props.className,isMobile = _props.isMobile;var


    name =




    contact.name,realtorImage = contact.realtor_image,licenseNumber = contact.licence_number,phone = contact.phone,_contact$staff_id = contact.staff_id,staffId = _contact$staff_id === undefined ? '' : _contact$staff_id;

    var realtorImageUrl = (0, _getUserLogoUrl2.default)(realtorImage);

    return (
      _react2.default.createElement(_ContactWrapper2.default, { className: (0, _classnames2.default)(_RealtorContact2.default.realtorContact, className) },
        _react2.default.createElement('img', {
          className: _RealtorContact2.default.logo,
          src: realtorImageUrl,
          alt: 'Logo of agent ' + name }),

        _react2.default.createElement('div', { className: (0, _classnames2.default)(_RealtorContact2.default.details, _RealtorContact2.default.realtorDetails) },
          name && !staffId &&
          _react2.default.createElement('p', {
              title: name,
              className: (0, _classnames2.default)(
              _RealtorContact2.default.text,
              _RealtorContact2.default.realtorName,
              _RealtorContact2.default.textEllipsis) },


            name),


          name && staffId &&
          _react2.default.createElement(_reactRouter.Link, {
              to: (0, _constructLink.constructStaffLink)(locale, staffId),
              title: name,
              className: (0, _classnames2.default)(
              _RealtorContact2.default.text,
              _RealtorContact2.default.link,
              _RealtorContact2.default.textEllipsis) },


            name),


          licenseNumber &&
          _react2.default.createElement('p', {
              className: (0, _classnames2.default)(
              _RealtorContact2.default.text,
              _RealtorContact2.default.realtorLicense,
              _RealtorContact2.default.textEllipsis) },


            translate('propertyDetails', 'contacts', 'licenseNumber'), ':', ' ',
            licenseNumber)),



        phone &&
        _react2.default.createElement(_PhoneButton2.default, {
          isMobile: isMobile,
          locale: locale,
          translate: translate,
          phone: phone,
          onClick: onRevealPhone })));




  };return RealtorContact;}(_react.Component);exports.default = RealtorContact;


RealtorContact.propTypes = {
  contact: _propTypes2.default.object.isRequired,
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  onRevealPhone: _propTypes2.default.func,
  className: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/BasicInformation/RealtorContact/RealtorContact.js
// module id = 1231
// module chunks = 0